import React from "react";
import { Layout } from "../store/layoutSlice";
import { useSelector } from "react-redux";
import { ReduxDataKey } from "../store/store";
import { remotePath } from "../settings/Paths";
import { CSS } from "src/_utils/styles";
import { useEBSSSLayout } from "../context/EBSSSLayoutContext/useEBSSSLayout";

const EBSSSLoadingCMS = ({ message, full }: { message?: string; full?: boolean }) => {
  const ebsssLayout: Layout = useSelector((state) => state[ReduxDataKey.LAYOUT]);
  const { trans } = useEBSSSLayout();

  // return ebsssLayout?.loader ? (
  //   <div className="d-flex flex-column align-items-center justify-content-center">
  //     <div dangerouslySetInnerHTML={{ __html: ebsssLayout?.loader }}></div>
  //     <span className="text-muted">{message}</span>
  //   </div>
  // ) : (
  return (
    <div className={`${full ? "loading-container" : "loading-container"} d-flex flex-column align-items-center justify-content-center`}>
      {ebsssLayout?.commonAppSettings?.customer_area_logo ? (
        <img
          alt="..."
          className="ebsss-load-breath-effect justify-content-center align-items-center"
          src={remotePath.assetsUrl(ebsssLayout.commonAppSettings.customer_area_logo)}
          width={100}
          height="auto"
        />
      ) : (
        <span className="ebsss-load-breath-effect justify-content-center align-items-center" style={{ width: 100, height: 100 }}>
          {trans("common.loading")}
        </span>
      )}
      <span className="text-muted mt-5">{message}</span>
    </div>
  );
};

export default EBSSSLoadingCMS;
